export const STAMPS_TO_COLLECT = 10;
